import React from "react";

const SooCoolPickList = React.forwardRef((props, ref) => {
  const { orders } = props;

  return (
    <div ref={ref} style={{ padding: 30 }}>
      <h1>Picklijst</h1>
      <div>
        {orders.map((order) => {
          return (
            <div
              style={{
                display: "flex",
                gap: 12,
                justifyContent: "space-between",
                alignItems: "flex-start",
                borderBottom: "1px solid darkgrey",
              }}
              key={order.id}
            >
              <div>
                <h4 style={{ margin: 0 }}>{order.farmorderCustomerName}</h4>
                <h6>{order.id}</h6>
              </div>
              <h4 style={{ margin: 0 }}>{`${order.totalKisten || "-"} kist(en)`}</h4>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default SooCoolPickList;
